import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

export class ProductTrackItemModel extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ProductTrackItemModel, v) : SKIP;
            },
            (v) => {
                return deserialize(ProductTrackItemModel, v);
            }
        );
    }

    constructor() {
        super();
        this._product = null;
        this._points = 0;
    }

    get product() {
        return this._product;
    }

    set product(value) {
        this._product = value;
    }

    get points() {
        return this._points;
    }

    set points(value) {
        this._points = value;
    }

    valid() {
        return !this.empty();
    }

    empty() {
        return !this.product || this.product.length === 0;
    }

    copy() {
        return this.clone();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ProductTrackItemModel());
        } else if (target instanceof ProductTrackItemModel) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ProductTrackItemModel, {
    _product: alias("product", Schema.primitive()),
    _points: alias("points", Schema.primitive())
})